<template>
  <div class="content">
      <s-location notice title="공지사항"/>


				<!-- <h4 class="sub_title02">공지사항</h4> -->


        <div class="right mb10">
          <!-- <input type="text" class="sch_input " title="검색" name="" value="" placeholder="검색(제목, 내용, 작성자)" /> -->

          <!-- <i-input-sel v-model="search.search_type" itemsp="all / 전체 | titl  / 제목 | cont / 내용 | name  / 작성자" />
          <i-input v-model="search.kword" @keyup.enter="doSearch"
            class="sch_input " title="검색" placeholder="검색(제목, 내용, 작성자)"
            /> -->
          <i-input-sel v-model="search.search_type" itemsp="all / 전체 | titl  / 제목 | cont / 내용 | name  / 작성자" />
          <input type="text" v-model="search.kword" @keyup.enter="doSearch()" class="mt0 "
            title="검색" placeholder="검색(제목, 내용, 작성자)"
            />
          <a @click.prevent="doSearch()" class="btn icon search_black2 ">검색</a>
        </div>

        <s-loading v-if="list.loading"/>
				<!-- 테이블 -->
				<table class="tbl01 board_list">
					<thead>
					  <tr>
					    <th class="no" >NO</th>
					    <th>제목</th>
					    <th class="day pc">등록일</th>
					  </tr>
					</thead>

<!-- 						<tr v-for="n in 5" :key=n>
							<td>{{ n }}</td>
							<td class="al_l"><router-link to="/board/board_view">법인 아리율 <span class="txt_new blink">new</span></router-link></td>
							<td>2019.04.01</td>
						</tr> -->

						<tr v-for="(item,idx) in list.items" :key=idx>
							<td class="al_c">{{ item.seq }}</td>
							<td @click="goDetail(item)" style="cursor: pointer">
                <span v-html="T.highlight(item.titl, $route.query.kword)" />
                <span v-if="T.isNew(item.incmgdt, 31)" class="txt_new blink"> new</span>
                <p class="m_date">{{ item.incmgdt | moment("YYYY.MM.DD") }}</p>
              </td>
							<td  class="al_c pc">{{ item.incmgdt | moment("YYYY.MM.DD") }}</td>
						</tr>
				</table>
				<!-- //테이블 -->
			    <!-- paging -->
				<div class="paging" v-if="list.totalCount > search.listSize">
					<p class="num">
 							<!-- <d:showNavi skin="front" pageNo="${ pageNo }" totalCount="${ listTotCnt }" listSize="${ listSize }" /> -->
               <s-page :pageNo.sync="search.pageNo" :totalCount="list.totalCount" :listSize="search.listSize" @changePage="doSearch"/>
					</p>
				</div>
				<!-- /paging -->

			</div> <!-- content : width=950px; -->

</template>

<style>
span.highlight { color: red; font-weight: bold; }
</style>


<script>
export default {
  data() {
    return {
      search: { kword : '', listSize : 10, pageNo : 1, },
      search_init: {},
      list: { loading: false, items: [], totalCount: 0 }
    }
  },
  watch: {
    '$route': 'getData'
  },
  created() {
    this.search_init = _.cloneDeep(this.search)
    this.getData();
  },

  methods: {
    doSearch(pageNo = 1) {
      this.search.pageNo = pageNo
      this.$router.push({ query: this.search })
    },
    goDetail(item) {
      this.$router.push({path: '/board/board_view', query: { seq: item.seq }})
    },
    getData() {
      T.setAttrs(this.search, this.$route.query, this.search_init)
      this.$ui.httpGetList(this.list
        , "/proc/N_ANN_SEL_LIST_ADM", {
            iv_mode     : 'FRONT',
            iv_pgsize : this.search.listSize,
            iv_page   : this.search.pageNo,
            iv_search_type : this.search.search_type || '',
            iv_search_text : this.search.kword || '',
            iv_permiss : 'M10300',
          }
        , ret => {
          this.list.totalCount = _.get(ret, "data.rs1[0].tot_rows", 0)
          this.list.items      = _.get(ret, "data.rs2", [])
        })

    },
  },
}
</script>

<style scoped>
  .sch_input { padding:8px;}

</style>